import React from 'react';
import classnames from 'classnames';

import { CountryCode, FLAG_IMPORTS } from '../../constants';
import './index.scss';

interface Props {
  className?: string;
  countryCode: CountryCode;
}

const Flag = function (props: Props) {
  return (
    <img
      className={classnames('Flag', props.className)}
      src={FLAG_IMPORTS[props.countryCode]}
      alt={props.countryCode}
    />
  );
};

Flag.displayName = 'Flag';

export default Flag;
